import moment, { type MomentInput } from 'moment'

/**
 * The local calendar day as `YYYY-MM-DD`. Use it instead of `toISOString().split('T')[0]`,
 * which gives the UTC day: the previous day between midnight and 01:00/02:00 in Brussels.
 */
export function localDateString(date: MomentInput = moment()): string {
  return moment(date).format('YYYY-MM-DD')
}

/**
 * Chronological comparator for date strings (local or UTC ISO) usable with `Array.sort`.
 * Subtracting two date strings gives NaN, which leaves the array unsorted.
 */
export function compareDates(
  firstDate: MomentInput,
  secondDate: MomentInput
): number {
  return moment(firstDate).valueOf() - moment(secondDate).valueOf()
}
